import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, Report } from './index';

export interface ReportByIdGetParams {
  id: string;
}

export const reportById = (payload: ReportByIdGetParams): Action<ReportByIdGetParams> => ({
  type: actions.reportByIdTrigger.toString(),
  payload,
});

export const reportByIdClear = (): Action => ({
  type: actions.reportByIdClear.toString(),
});

export const reportByIdErrorClear = (): Action => ({
  type: actions.reportByIdErrorReset.toString(),
});

export function* reportByIdRequestSaga({ payload }: Action<ReportByIdGetParams>) {
  yield put({
    type: actions.reportByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.reportByIdError.toString(),
      payload: {
        message: 'ReportById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/reports/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<Report, Report>(
    response,
    actions.reportByIdSuccess.toString(),
    actions.reportByIdError.toString(),
    false,
    (reportByIdData) => reportByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.reportByIdTrigger.toString(),
    defaultProcessingSaga(
      reportByIdRequestSaga,
      {
        error: actions.reportByIdError.toString(),
        locationCancel: actions.reportByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.reportByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.reportByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.reportByIdErrorReset.toString(),
    });
  });
}
